require("bijou/base");
require("bijou/jquery-ui");

(function ($) {
  "use strict";

  // Customised autocomplete widget
  $.widget("tradeselector.tradeautocomplete", $.ui.autocomplete, {
    options: {
      position: { of: false }, // No positioning
      minLength: 2,
      delay: 0,
      headings: {
        exact: "Exact matches for your search",
        suggested: "Suggested matches",
        "no-results": "Sorry, that's not a trade we know! Please try again",
      },
    },

    _create: function () {
      this._super();
      this.widget().menu("option", "items", "> :not(.js-result-heading)");
      var defaultTradeDescriptionLengthToDisplayReadMore = 320;
      this.tradeDescriptionLengthToDisplayReadMore = parseInt(
        this.element.data("trade-description-length-to-display-read-more") ||
          defaultTradeDescriptionLengthToDisplayReadMore,
      );
      this.element.attr({
        autocorrect: "off",
        autocapitalize: "none",
        spellcheck: false,
      });
    },

    _renderMenu: function (ul, items) {
      var _this = this,
        currentType = "";

      $.each(items, function (index, item) {
        if (item.type !== currentType) {
          var heading = _this.options.headings[item.type];

          if (
            _this.options.enableViewAllTrades &&
            _this.options.primaryDetail
          ) {
            if (item.type === "no-results") {
              heading =
                '<a href="/trades?referrer=no-trades&q=' +
                encodeURIComponent(_this.term) +
                "&vertical=" +
                item.vertical +
                '" class="view-all-trades">View all trades</a>';
            } else if (item.type === "suggested") {
              heading =
                'Suggested matches, or <a href="/trades?referrer=suggested-trades&q=' +
                encodeURIComponent(_this.term) +
                "&vertical=" +
                item.vertical +
                '" class=" view-all-trades">view full list of professions</a>';
            }
          }

          ul.append(
            '<li class="js-result-heading heading ' +
              item.type +
              '">' +
              heading +
              "</li>",
          );

          currentType = item.type;
        }
        if (item.value != "No results") {
          _this._renderItemData(ul, item);
        }
      });
    },

    _renderItem: function (ul, item) {
      var tradeDescription = item.definition;

      var item = $("<li>")
        .attr("data-value", item.value)
        .addClass("qa-" + item.type)
        .append($("<a>").html(item.label));

      if (tradeDescription) {
        var tradeDescriptionElement =
          this._renderTradeDescriptionElement(tradeDescription);

        item.append(tradeDescriptionElement);
      }

      return item.appendTo(ul);
    },

    _renderTradeDescriptionElement(tradeDescription) {
      var descriptionContainer = $('<div class="trade-description-container">');

      var trimmedTradeDescription = `${tradeDescription.substring(0, this.tradeDescriptionLengthToDisplayReadMore - "...".length)}...`;
      var tradeDescriptionText =
        tradeDescription.length > this.tradeDescriptionLengthToDisplayReadMore
          ? trimmedTradeDescription
          : tradeDescription;

      var tradeDescriptionTextElement = $(
        '<div class="trade-description">',
      ).html(tradeDescriptionText);

      if (
        tradeDescription.length > this.tradeDescriptionLengthToDisplayReadMore
      ) {
        var readMoreText = $('<span class="read-more-text">').html("Read more");

        var readMoreElement = $('<button class="read-more">')
          .click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            var text = this.querySelector(".read-more-text");
            var chevron = this.querySelector(".chevron");

            if (text.textContent == "Read more") {
              text.textContent = "Read less";
              chevron.classList.remove("chevron-down");
              chevron.classList.add("chevron-up");
              tradeDescriptionTextElement.html(tradeDescription);
            } else {
              tradeDescriptionTextElement.html(trimmedTradeDescription);
              text.textContent = "Read more";
              chevron.classList.remove("chevron-up");
              chevron.classList.add("chevron-down");
            }
          })
          .append(readMoreText)
          .append($('<span class="chevron chevron-down">'));
      }

      return descriptionContainer
        .append(tradeDescriptionTextElement)
        .append(readMoreElement);
    },

    // Disable menu resizing
    _resizeMenu: function () {
      return;
    },
  });

  function getURLParam(param) {
    if (window.URLSearchParams) {
      // not supported by IE11
      return new URLSearchParams(window.location.search).get(param);
    } else {
      var results = new RegExp("[?&]" + param + "=([^&#]*)").exec(
        window.location.href,
      );
      return results ? decodeURI(results[1]) : null;
    }
  }
  //  A trade selector allows a user to search through a list of trades and pick
  //  the trade that best represents what they do.
  //  In the simplest scenario, a trade selector calls an API endpoint to search
  //  for a specified string within the list of all possible trades.
  //
  //  Each trade belongs to one or more verticals.
  //  This allows us to support two important features of the trade selector:
  //  - Redirection: the trade selector can be configured with a current vertical.
  //    If a trade belonging to a different vertical is selected, the selector
  //    can redirect the user to another page (ideally to switch to the most
  //    appropriate vertical for the selected trade).
  //  - Search scope: The trade selector can be configured to restrict search
  //    results to a subset of trades based on vertical.
  //    See SearchScope.md and TradeSelector::Client for details.
  $.widget("tradeselector.trade_search", $.bijou.base, {
    options: {
      minLength: 2,
      searchUrl: null, // Endpoint to call to get search results back
      currentVertical: null, // Which vertical is the trade selector being displayed for at the moment (optional)
      redirectUrl: null, // When a trade is selected that doesn't belong to currentVertical, the browser will redirected here (optional)
      searchScope: null, //  Scope for the search, based on vertical (optional)
    },

    _create: function () {
      var tradeSelect = this.element.find("select");

      // Initialize currentResults to avoid undefined errors in _trackChanges
      this.currentResults = [];

      // If we find a select input, then we are in failover mode
      if (tradeSelect.length) {
        this._on(tradeSelect, {
          change: function () {
            var selectedOption = tradeSelect
              .find("option")
              .eq(tradeSelect[0].selectedIndex);
            var selectedVertical = selectedOption.attr("vertical");
            var supportedVerticals = selectedOption.attr("supported_verticals");

            if (this._shouldRedirect(selectedVertical, supportedVerticals)) {
              this._redirect(selectedVertical, tradeSelect.val());
            }
          },
        });

        // This is all we need to do in this mode so return
        return;
      }

      var _this = this;
      var searchUrl = this.options.searchUrl;

      this.breakpointEnabled();

      this.element.attr("tabindex", -1);

      this.inputElement = this.element.find(".js-search-input");
      this.tradeInput = this.element.find(".js-trade-input");
      this.answerPlaceholder = this.element.find(".answer");
      this.tradeTypePlaceholder = this.element.find(".trade-type");
      this.tradeDetailPlaceholder = this.element.find(".trade-detail");
      this.answerPlaceholder = this.element.find(".answer");
      this.menuElement = this.element.find(".results");
      this.tradePrefilled =
        this.element.data("trade-prefilled") === true &&
        !!this.tradeInput.val();

      // Trigger event if the trade is already set
      //Note: This likely will cause primary_detail_selected event to fire duplicatively in redirection scenarios that terminate on a page that contains this code 
      if (this.tradeInput.val()) {
        this._trackChanges();
      }

      this.inputElement.tradeautocomplete({
        appendTo: this.menuElement,
        minLength: this.options.minLength,
        enableViewAllTrades: this.options.enableViewAllTrades,
        primaryDetail: this.options.primaryDetail,
        source: function (request, response) {
          _this._search(request.term).done(function () {
            response(_this.currentResults);
          });
        },
      });

      this._on(this.inputElement, {
        focus: function () {
          this._switchMode("search");

          if (this.currentResults.length === 0) {
            this.inputElement.tradeautocomplete("search");
          } else {
            this.element.addClass("open");
            this.menuElement.find("ul").show();
          }

          this._scrollToTop();
        },

        input: function () {
          // Ensure field is visible when input changes
          // e.g. on a mobile screen when typing while input is off screen
          if (
            this.window.scrollTop() >
            this.inputElement.closest(".control").offset().top
          ) {
            this._scrollToTop();
          }
        },

        tradeautocompleteselect: function (event, ui) {
          this._select(ui.item);
          return false;
        },

        tradeautocompletesearch: function (event, ui) {
          this._resetValidation();
        },

        tradeautocompleteopen: function () {
          this.element.addClass("open");
        },

        tradeautocompleteclose: function (event, ui) {
          this.element.removeClass("open");
        },

        keypress: function (e) {
          if (e.keyCode === $.ui.keyCode.ENTER) {
            var val = $.trim(this.inputElement.val()).toLowerCase();
            var selected;

            $.each(this.currentResults, function (index, item) {
              if (item.value && item.value.toLowerCase() === val) {
                selected = item;
                return false;
              }
            });

            if (selected) {
              this._select(selected);
              // Prevent any default behaviour like submitting the form
              e.preventDefault();
            }
          }
        },
      });

      this._on({
        "click .js-change": function (e) {
          var valLength = this.inputElement.val().length;
          var inputDOMElement = this.inputElement[0];

          e.preventDefault();
          this._switchMode("search");
          this.inputElement.focus();

          if (inputDOMElement.setSelectionRange) {
            inputDOMElement.setSelectionRange(valLength, valLength);
          } else if (inputDOMElement.createTextRange) {
            // Fallback for IE8
            var range = inputDOMElement.createTextRange();
            range.collapse(true);
            range.moveEnd("character", valLength);
            range.moveStart("character", valLength);
            range.select();
          }
        },

        questionHide: function () {
          this._switchMode("search");
          this.inputElement.val("");
          this.inputElement.tradeautocomplete("close");
        },
      });

      this._on(this.options.form, {
        validate: function (e) {
          if (!this._validate()) {
            e.preventDefault();
          }
        },
      });
    },

    _search: function (term) {
      var _this = this;

      if (this.xhr) {
        this.xhr.abort();
      }

      var requestData = {
        q: term,
        path: window.location.pathname,
      };

      if (this.options.currentVertical) {
        requestData.vertical = this.options.currentVertical;
      }

      if (this.options.backoffice) {
        requestData.backoffice = this.options.backoffice;
      }

      if (this.options.primaryDetail) {
        requestData.primary_detail = this.options.primaryDetail;
      }

      if (this.options.searchScope) {
        requestData.search_scope = this.options.searchScope;
      }
      return (this.xhr = $.getJSON(
        this.options.searchUrl,
        requestData,
        function (data) {
          _this.currentResults = data.results;

          _this.tradeInput.data('search-id', data['search_id'])

          // Add a 'no results' heading when no results returned
          if (_this.currentResults.length === 0) {
            _this.currentResults.push({
              label: "No results",
              value: "No results",
              type: "no-results",
              vertical: requestData.vertical,
            });
          }
        },
      ));
    },

    _switchMode: function (mode) {
      if (mode === "search") {
        this.element
          .addClass("state-search")
          .removeClass("state-selected")
          .removeClass("state-blocked");
      } else if (mode === "blocked") {
        this.element.addClass("state-blocked");
        this.inputElement.blur();
      } else {
        this.element.removeClass("state-search").addClass("state-selected");
      }
      this._trigger("switch", null, mode);
    },

    _select: function (item) {
      this.inputElement.val(item.value);
      this.tradePrefilled = false; // Reset prefilled flag when user selects

      // Store pre_filled_source in sessionStorage for trade added in coverage selection
      const searchScope = this.options.searchScope;
      const businessUnit = this.options.businessUnit;
      if (
        searchScope === "Coverage selection" &&
        businessUnit === "simplybusiness_us"
      ) {
        sessionStorage.setItem("preFilledSource", "trade_selector_pre_app");
      }

      if (item.blocked) {
        this._trigger("change", null, {
          trade: item.value,
          vertical: item.vertical,
        });
        this.tradeInput.val(item.value);
        this.tradeInput.trigger("change");
        this._trackChanges();
        this._switchMode("blocked");
      } else if (
        this._shouldRedirect(item.vertical, item.supported_verticals)
      ) {
        this.tradeInput.val(item.value);
        this.tradeInput.trigger("change");
        this._trackChanges(item.vertical);
        this._redirect(item.vertical, item.value);
      } else {
        this._trigger("change", null, {
          trade: item.value,
          vertical: item.vertical,
        });
        this._resetValidation();
        this.tradeInput.val(item.value);
        this.tradeInput.trigger("change");
        this._trackChanges();
        this.answerPlaceholder.text(item.value);
        if (item.trade_detail && this.tradeDetailPlaceholder[0])
          this.tradeDetailPlaceholder.text(item.trade_detail);
        if (item.trade_type && this.tradeTypePlaceholder[0])
          this.tradeTypePlaceholder.text(item.trade_type);
        this._switchMode("selected");
        this.element.focus();
      }
    },

    _resetValidation: function () {
      // Reset validation on search input
      if (!this.options.form) return;
      this.options.form.validate().resetField(this.inputElement);
    },

    _validate: function () {
      if (
        (this.element.hasClass("state-selected") &&
          this.element.hasClass("on")) ||
        this.element.hasClass("off")
      ) {
        return true;
      }
      this._scrollToTop();
      return false;
    },

    _shouldRedirect: function (vertical, supported_verticals) {
      // Never attempt redirect if redirectUrl is not set
      if (this.options.redirectUrl === null) {
        return false;
      }

      if (
        this.options.currentVertical == "contractors_combined" &&
        vertical != "contractors_combined"
      ) {
        return !(
          supported_verticals &&
          supported_verticals.includes("contractors_combined")
        );
      }
      if (
        this.options.currentVertical == "commercial_combined" &&
        vertical != "commercial_combined"
      ) {
        return !(
          supported_verticals &&
          supported_verticals.includes("commercial_combined")
        );
      }

      if (
        this.options.currentVertical == "business_owners_policy" &&
        vertical != "business_owners_policy"
      ) {
        return !(
          supported_verticals &&
          supported_verticals.includes("business_owners_policy")
        );
      }

      return vertical && this.options.currentVertical !== vertical;
    },

    _redirect: function (vertical, trade) {
      if (window.BackofficeEventTracker) {
        BackofficeEventTracker.trigger("backoffice_vertical_changed", vertical);
      }

      var pathSegments = window.location.pathname.split("/").filter(Boolean);
      var journeyId = pathSegments[pathSegments.length - 1];
      var journeyName = pathSegments[pathSegments.length - 3];
      var originalVertical = this.options.currentVertical;
      var affclie = getURLParam("AFFCLIE");

      var url =
        this.options.redirectUrl +
        "?vertical=" +
        encodeURIComponent(vertical) +
        "&trade=" +
        encodeURIComponent(trade) +
        "&journey_id=" +
        encodeURIComponent(journeyId);

      if (journeyName) {
        url += "&journey_name=" + encodeURIComponent(journeyName);
      }

      if (originalVertical) {
        url += "&original_vertical=" + encodeURIComponent(originalVertical);
      }

      if (affclie) url += "&AFFCLIE=" + encodeURIComponent(affclie);

      window.location = url;
    },

    //If verticalOverride is provided, it will be used for the event instead of the current vertical
    _trackChanges: function (verticalOverride = null) {
      if (window.EventTracker && this.options.trackedEvent) {
        const businessUnit = this.options.businessUnit;
        const searchID = this.tradeInput.data("search-id");
        const searchScope = this.options.searchScope;
        const tradeResults = this.currentResults.map((item) => item.value);

        const searchIndex =
          tradeResults.length > 0
            ? tradeResults.indexOf(this.tradeInput.val())
            : -1;

        const verticalOverrideValue = verticalOverride
          ? (verticalOverride =
              verticalOverride.charAt(0).toUpperCase() +
              verticalOverride.slice(1))
          : verticalOverride;
        EventTracker.trigger(
          this.options.trackedEvent,
          this.tradeInput,
          false,
          searchID,
          verticalOverrideValue,
          businessUnit,
          searchScope,
          searchIndex,
          this.tradePrefilled
        );
      }
    },

    _scrollToTop: function () {
      if (
        this.options.breakpoint === "mobile" ||
        this.element.hasClass("state-blocked")
      ) {
        var scrollPos = this.inputElement.closest(".control").offset().top;
        if (scrollPos !== this.window.scrollTop()) {
          window.scrollTo(0, scrollPos);
          setTimeout(function () {
            window.scrollTo(0, scrollPos);
          }, 400);
        }
      }
    },
  });
})(window.jQuery);
